import React from 'react'

import { AnalyticsEvent, CTATheme, mq } from '../../utils'
import Modal, { ModalSize } from 'marketing-site/src/components/common/Modal'
import useModalOpenState from 'marketing-site/lib/useModalOpenState'
import { CTAButton } from '../../elements/CTAButton'
import { TranscriptButton } from '../../elements/TranscriptButton'
import { CTAOrVariationContainer } from 'marketing-site/src/transformers/CTA'

import { Hero } from '../Hero'
import { IProps } from './index'

export const HeroWithVideo: React.FC<IProps> = ({
  ctaButtonText,
  eyebrow,
  headline,
  posterImage,
  renderModalContent,
  subheading,
  transcriptButton,
  alignment,
  showPosterAfterHeadline,
  cta,
  secondaryCta,
  eventContext,
  eventObjectName,
}) => {
  const [modalOpen, openModal, closeModal] = useModalOpenState()

  function renderAuxContent() {
    const handleOnClick = () => {
      if (eventContext && eventObjectName) {
        const analyticsEvent = new AnalyticsEvent({
          action: 'clicked',
          object: eventObjectName,
          context: eventContext,
        })

        analyticsEvent.setPlaceFromPath(window.location.pathname)
        analyticsEvent.send()
      }

      openModal()
    }

    return (
      <button
        className="hero-with-video__video-poster-button"
        onClick={handleOnClick}
        type="button"
      >
        <img src={posterImage} className="hero-with-video__poster-image" alt="Video Poster" />
        <style jsx>
          {`
            .hero-with-video__video-poster-button {
              margin-top: 1.75rem;
              cursor: pointer;
              border-radius: 25px;
              position: relative;
              overflow: hidden;
              font-size: 0;
            }

            .hero-with-video__poster-image {
              width: 100%;
            }

            @media (${mq.tablet}) {
              .hero-with-video__video-poster-button {
                margin-top: 4rem;
              }
            }
          `}
        </style>
      </button>
    )
  }

  const leftAlign = alignment && alignment === 'OneColumn' ? false : true

  return (
    <Hero
      eyebrow={eyebrow}
      headline={headline}
      subheading={subheading}
      media={{
        renderAuxContent: renderAuxContent,
        placeAfterHeadline: showPosterAfterHeadline,
      }}
      layout={{
        leftAlign,
        compact: true,
      }}
      renderMainContent={() => (
        <>
          <div className="hero-with-video__cta-wrapper">
            {cta ? (
              <CTAOrVariationContainer {...cta} elementLocation="hero" />
            ) : (
              <CTAButton
                arrow={false}
                text={ctaButtonText}
                onClick={openModal}
                bgColor={CTATheme.BlackFill}
              />
            )}
            {secondaryCta && <CTAOrVariationContainer {...secondaryCta} elementLocation="hero" />}
          </div>

          {transcriptButton && <TranscriptButton {...transcriptButton} />}

          <Modal isOpen={modalOpen} onRequestClose={closeModal} size={ModalSize.Medium}>
            {renderModalContent()}
          </Modal>

          <style jsx>
            {`
              .hero-with-video__cta-wrapper {
                display: flex;
                grid-gap: 1rem;
                justify-items: ${!leftAlign ? 'center' : 'stretch'};
              }

              @media (${mq.tablet}) {
                :global(.cta .email-form) {
                  max-width: 450px;
                }
              }
            `}
          </style>
        </>
      )}
    />
  )
}
